module.exports = __webpack_public_path__ + "static/media/oval.2778831a.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img/oval.png
// module id = 140
// module chunks = 0